angular.module('impactx.sidebar').directive('ixUserMenu', function () {
    return {
        scope: {
            importantItems: '=',
            menuItems: '=',
            currentWorkspaceId: '='
        },
        controller: 'UserMenuCtrl',
        controllerAs: 'userMenuCtrl',
        restrict: 'E',
        templateUrl: 'modules/sidebar/templates/user-menu.tmpl.html'
    };
});